var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"show"},[_c('h1',{staticClass:"title"},[_vm._v("Specific Show")]),_c('ShowCard',{attrs:{"show":_vm.show},on:{"set-tracks":_vm.setTracks}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }